<template>
    <div class="single-answer">
        <div class="question-title" id='contentItem' ref='contentItem'>Question {{question.questionNo}}</div>
        <div class="question-part">
            <div class="que-row">
                <div class="que-col-1">&nbsp;</div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor  :read-only="isEditable" :editorUrl="editorURL"  v-model="question.question_text " :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false}"></ckeditor>
                    </div>
                </div>
            </div> 
        </div>
         <div class="question-title">Answer</div> 
        <div class="ans-part">
            <div class="que-row">
                <div class="que-col-1">&nbsp;</div>
                <div class="que-col-2">
                    <v-text-field v-model="question.correct_answer" type="number" @paste.prevent @keydown.space.prevent @keypress="allowedOnlyNumber($event)" outlined dense hide-details></v-text-field>
                </div>
            </div>
        </div>  
        <!-- <div class="question-title">Hints</div>
        <div v-for="(hint,hi) in question.hints" :key="hi" class="ans-part">
            <div class="que-row">
                <div class="que-col-1">
                    <span class="delete-icon">{{hi+1}}.<v-icon   @click="removeHint" >mdi-delete-circle</v-icon></span>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorUrl"  v-model="hint.text" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="que-row add-sl-opction">
            <div class="que-col-1">&nbsp;</div>
            <div class="que-col-2">
                <div v-if="shouldShowAddHint" @click="addNewHint()" class="add-opction">
                    <div class="circle-icon">
                        <v-icon>mdi-plus-circle</v-icon> 
                        <span>Add Hint</span>
                    </div>
                </div>
            </div>
        </div> -->


        <div class="question-title">Solution</div>
        <div class="ans-part">
            <div class="que-row">
                <div class="que-col-1">&nbsp;</div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :read-only="isEditable" :editorUrl="editorURL"  v-model="question.solution" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-align">
            <v-btn @click="onNextQuestion({})" v-if="showNextButton" class="right-btn cust-btn" color="primary">{{question.btnText}}</v-btn>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Integer',
    props: ['question','onNextQuestion', 'showNextButton','isEditable'],
    data() {
        return {
            
        }
    },
    mounted()
    {
      this.setDefaultData();
        
    },
    methods:{
       
        addNewHint()
        {
             this.question.hints.push( {
                       text:''
                    })
        },
        removeHint(index)
        {
             this.question.hints.splice(index,1);
        },
        setDefaultData()
        {
                 this.question.hints=this.question && this.question.hints&&this.question.hints.length ? this.question.hints :[{ text: "" }];
         this.question.options=this.question && this.question.options&&this.question.options.length ? this.question.options : [
                    {
                        index: this.OPTIONS_ABC[0],
                        option_text: "",
                        correct_answer: false
                    },
                    {
                        index: this.OPTIONS_ABC[1],
                        option_text: "",
                        correct_answer: false
                    },
                    {
                        index: this.OPTIONS_ABC[2],
                        option_text: "",
                        correct_answer: false
                    },
                    {
                        index: this.OPTIONS_ABC[3],
                        option_text: "",
                        correct_answer: false
                    },
                ];
        }
    },
    computed:{
        shouldShowAddoption()
        {
            return this.question.options.length<this.OPTIONS_ABC.length
        },
        shouldShowAddHint()
        {
            return this.question.hints.length<this.OPTIONS_ABC.length
        }
    },
    watch:{
        question(val)
        {
                this.setDefaultData();
                 document.getElementById('contentItem').scrollIntoView();
        },
        
    }
 }
</script>